<!-- Root layout -->

<div class="min-h-screen flex flex-col">
  <app-top-menu class="flex-none menu-open"></app-top-menu>
  <app-maintenance-banner></app-maintenance-banner>
  <!-- No page scroll -->
  <main class="flex-1 overflow-hidden min-h-0">
    <router-outlet></router-outlet>
  </main>
</div>


<!-- Global loading overlay -->
<div class="loading-overlay" *ngIf="loadingService.loading$ | async">
  <div class="loading-content">
    <div class="loading-spinner"></div>
    <h2>Please wait...</h2>
    <p>You are being redirected to our secure payment page.</p>
  </div>
</div>